import { tv } from "@ui/lib/tv";

/** Shared visual vocabulary for the slider family (Slider, RangeSlider, PriceRange). */
export const sliderStyles = tv({
  slots: {
    root: "w-full",
    track: "relative h-1 w-full rounded-full bg-neutral-100",
    // SliderFill positions and sizes itself from slider state; only paint here.
    fill: "rounded-full bg-red-400",
    thumb: [
      "top-1/2 size-6 rounded-full border-2 border-red-400 bg-white shadow-md",
      "focus-visible:outline-2 focus-visible:outline-focus-ring focus-visible:outline-offset-2",
      "dragging:cursor-grabbing",
    ],
  },
});
